import styled from 'styled-components'

export const HeaderBox = styled.div`
    align-items: center;
    display: flex;
    margin-bottom: 20px;
    width: 100%;
`
export const sectionTitle = styled.div`
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
    white-space: nowrap;
    margin-right: 15px;

    span {
        padding-right: ${(props) => (props.divider ? '	15px' : '0px')};
        text-align: ${(props) => (props.divider ? 'left' : 'center')};
        width: ${(props) => (props.divider ? 'auto' : '100%')};
    }

    &:after {
        content: ${(props) => (props.divider ? "''" : 'none')};
        border-top: ${(props) =>
            props.divider ? `3px solid ${props.borderColor}` : 'none'};
        display: ${(props) => (props.divider ? 'table-cell' : 'none')};
        position: relative;
        width: 100%;
    }
`
export const BtnHeaderBox = styled.div`
    display: flex;
    gap: 15px;
    margin-left: 15px;
`
